import { FC } from "react";
import { SearchFormInputs } from "src/Modules/Flights/constants";
import {
  OriginComponent,
  DestinationComponent,
  PassengerClassSelection,
  DepartureComponent,
  ArrivalComponent,
  DirectFlightComponent,
  SubmitComponent,
  TripSelectionComponent,
} from "../../FlightSearchForm";
import { useTranslation } from "react-i18next";

const SearchMobileLayout: FC<{ values: Partial<SearchFormInputs>; errorFields: string[] }> = ({ values, errorFields }) => {
  const { t } = useTranslation();
  return (
    <div className="flex w-full flex-col items-start justify-center gap-2 p-5 rounded-2xl">
      <TripSelectionComponent />
      <div className="flex w-full flex-col gap-8 rounded-2xl p-4 px-4 outline outline-border-default">
        <OriginComponent errorFields={errorFields} />
        <DestinationComponent errorFields={errorFields} />
        <DepartureComponent errorFields={errorFields} />
        <ArrivalComponent values={values} errorFields={errorFields} />
        <PassengerClassSelection label={t("Flights.search.passengersAndClass")} />
        <DirectFlightComponent />
      </div>
      <div className="w-full">
        <SubmitComponent />
      </div>
    </div>
  );
};

export default SearchMobileLayout;
